import './set-public-path'
import Vue from 'vue'
import singleSpaVue from 'single-spa-vue'
import { i18n } from '@leapsight/portal'

import router from './router'
import vuetify from './plugins/vuetify'
// Local vuex store
import store from './store/index'
import App from './App.vue'
import * as VueGoogleMaps from 'vue2-google-maps'

console.log('## process.env.VUE_APP_GOOGLE_KEY = ',process.env.VUE_APP_GOOGLE_KEY)

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.use(require('moment'))
Vue.use(VueGoogleMaps, {
  load: {
//PROD
//    key: 'AIzaSyAVCEISirUj2z6G0ZRuzG-bPJtwKqeeqJE'
//TEST
//    key: 'AIzaSyDj6o3z8SlCeVVTn7X8Y_iCJn2r3ewaCX0'
    key: process.env.VUE_APP_GOOGLE_KEY
  }
})

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render: (h: any) => h(App),
    router,
    store,
    vuetify,
    i18n
  }
})

export const bootstrap = vueLifecycles.bootstrap
export const mount = vueLifecycles.mount
export const unmount = vueLifecycles.unmount
